import moment from 'moment-timezone';

/**
 * Date utils for various shift properties.
 *
 * @namespace DateUtils
 * @type {Object}
 */
const DateUtils = {
	getDateByOffset: (_periodIndex, offset) =>
		moment
			.utc()
			.day(offset)
			.subtract(-7 * _periodIndex, 'days'),

	getFormattedDateByOffset: (_periodIndex, offset) => DateUtils.getDateByOffset(_periodIndex, offset).format('ddd M/D'),
	DAYS_IN_WEEK: 7
};

export default DateUtils;
